import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

export default function VideoCard({ video }: { video: VideoItem }) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-500/70 transition-all duration-300 animate-fade-up cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.cover}
          alt={`${video.title} 视频封面`}
          title={`${video.title} - 黄瓜视频App`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md text-xs font-label bg-primary-500 text-background-950">
          {video.type}
        </span>
        <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md text-xs font-label bg-background-950/80 text-foreground-200">
          {video.duration}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 rounded-full bg-primary-500/90 text-background-950 flex items-center justify-center">
            <i className="ri-play-fill text-2xl" />
          </span>
        </span>
      </div>
      <div className="p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-400 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {video.description}
        </p>
        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-500" />
          <span>{video.region}</span>
          <span className="ml-auto flex items-center gap-1 text-accent-400">
            <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
            {video.hot}
          </span>
        </div>
      </div>
    </Link>
  );
}